// client/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/* ──────────────────────────────────────────────
   Global console filter to hide noisy debug / GA logs
   (does NOT stop any actual network calls)
   ────────────────────────────────────────────── */
(function installConsoleNoiseFilter() {
  if (typeof window === 'undefined') return;

  const GA_RE = /google-analytics|region\d*\.google-analytics\.com|analytics\.js|gtag|googletagmanager|gtm\.js/i;
  const FETCH_RE = /^Fetch (finished|failed) loading:/;
  const PIXI_DEPRECATION_RE = /PixiJS Deprecation Warning: Setting interactive is deprecated/i;
  const VTT_PIXI_RE = /\[VTT\]\s*window\.PIXI\s*=\s*undefined/i;

  const shouldSilence = (joined) => {
    if (GA_RE.test(joined)) return true;
    if (FETCH_RE.test(joined)) return true;
    if (PIXI_DEPRECATION_RE.test(joined)) return true;
    if (VTT_PIXI_RE.test(joined)) return true;
    return false;
  };

  try {
    const wrap = (methodName) => {
      const orig = console[methodName] ? console[methodName].bind(console) : null;
      if (!orig) return;
      console[methodName] = (...args) => {
        const joined = (args || []).map(a => {
          try {
            if (typeof a === 'string') return a;
            if (a && a.message) return a.message;
            return JSON.stringify(a);
          } catch {
            return String(a);
          }
        }).join(' ');
        if (shouldSilence(joined)) return;
        orig(...args);
      };
    };

    wrap('log');
    wrap('info');
    wrap('warn');
    wrap('error');
    wrap('debug');
  } catch {
    // if anything blows up, do nothing and leave console alone
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
